/* eslint-disable */
/* Please refactor this file, I temporarily disabled lint on this file to remove the long warnings */
/* Warnings may cause errors or false positive bugs on javascript, lets avoid that */

import React, { Component } from 'react';
import Modal from './UserProfileModal/Modal';
import UploadFile from './UserProfileModal/UploadFile';
import DefaultBody from './UserProfileModal/DefaultBody';
import Camera from './UserProfileModal/Camera';
import {Checkbox} from '../../commons/Inputs';
import ModalCommon from '../../commons/Modal/Modal';
import axios from 'axios';
import appConfig from '../../../config';
import {browserHistory} from 'react-router';
import SMSModal from './SMSModal';

let $ = window.jQuery;
let moment = window.moment;

export default class UserProfile extends Component {

	state = {
		modalBody : null,
		visible : true,
		visibleUpload : false,
		visibleCamera : false,
		imgSrc : '',
        savedImg: '',
        patient_name: '',
        showId: '',
        age : 0,
        gender : '',
        civil_status : '',
        contact_number : '',
        profilePosition : true,
        styleChange : {position : 'relative'},
        isProfileState : true,
        isSaving : false,
        checkedItems : {patientInfo : 1,dentalHistory : 1,medicalHistory : 1,charting : 1,treatmentRecord : 1,gallery : 1,prescription : 1},
        stateView : '',
        isDeleting : false
	}

	componentWillReceiveProps(nextProps) {
		// console.log(Object.keys(nextProps.data));
		// console.log(nextProps.data);

		if (nextProps.data !== this.props.data) {
			if (nextProps.data) {
				let contactLenth = (typeof nextProps.data.user.user_phone_numbers !== 'undefined' ? nextProps.data.user.user_phone_numbers.length : 0);

				this.setState({
					savedImg : nextProps.data.user.media_id && nextProps.data.user.media_id !== '0' ? appConfig.staticFiles + nextProps.data.user.media_id : '',
					patient_name : nextProps.data.user.firstname + ' ' + nextProps.data.user.lastname,
					showId : nextProps.data.id,
					age : nextProps.data.user.birthdate,
					gender : nextProps.data.user.gender,
					civil_status : nextProps.data.user.civil_status,
					contact_number : (nextProps.data.user.user_phone_numbers ? (nextProps.data.user.user_phone_numbers.length > 0 ? nextProps.data.user.user_phone_numbers[contactLenth - 1].number : '') : ''),
					isProfileState : true
				});
			}
		}
	}

	componentDidMount() {
        if(!this.props.scrollState) // profile content
        {
        	this.onWindowScroll();	
        }
	}

	onWindowScroll = () => {
		$(window).scroll((e) => {

			if(!this.state.isProfileState)
        	{
        		return; // if this userProfile is Unmounted
        	}

            if($(e.target).scrollTop() >= 170)
            {
            	this.setState({
            		profilePosition : false,
            		styleChange : {position : 'fixed',zIndex : 9, top : '68px',width : '100%',left : 0}
            	});
            }else{
            	this.setState({
            		profilePosition : true,
            		styleChange : {position : 'relative'}
            	});
            }
        });
	}

	componentWillUnmount() {
		this.state.isProfileState = false; // to prevent warning setState can only update a mounted or mounting component
	}

	onUpload = (e) => {
		
		var files = e.target.files;

        // Loop through the FileList and render image files as thumbnails.
        for (var i = 0, f; f = files[i]; i++) {
            // Only process image files.
            if (!f.type.match('image.*')) {
                continue;
            }
            var reader = new FileReader();

            // Closure to capture the file information.
            reader.onload = ((theFile) => {
                return (e) => {
                    // pass the result to img tag

					this.setState({
						visible : false,
						visibleUpload : true,
						imgSrc : e.target.result
					});
                };
            })(f);

            // Read in the image file as a data URL.
            reader.readAsDataURL(f);
        };
		
	}

	onCancel = () => {
		if(typeof window.strem !== 'undefined')
		{
			window.stream.getVideoTracks()[0].stop();
		}

		this.setState({
			visible :  true,
			visibleUpload : false,
			visibleCamera : false
		});
	}

	onSave = (e) => {

		// disabled button
		$(e.target).addClass('disabled');

		const url = appConfig.apiUrl + 'media/upload';

		if(e.target.value == 'upload')
		{
			let form = new FormData($('#uploadFileForm')[0])
			let file = document.getElementById('imageUploadFile');
			form.append('file',file.files[0]);

			axios({
	            url: url,
	            method: 'post',
	            responseType: 'json',
	            data : form,
	            progress: (progressEvent) => {
	            	console.log(progressEvent)
			        let percentCompleted = progressEvent.loaded / progressEvent.total;
			        
			        let html = (percentCompleted * 100) + '% completed';
			        
			        $('.modal-body').block({
			        	message : html
			        });
			    }
	        }).then((response) => {

				this.setState({
                    savedImg: appConfig.staticFiles + response.data.data.name
				},() => {
					
		            document.getElementById('media_id').value = response.data.data.name;
		            
		            // if(this.props.scrollState == 'profile')
		            // {
		            // 	$('.tenantProfilePic').attr('src',appConfig.staticFiles + response.data.data.name);
		            // }

		            this.props.onMediaChoice(e);
		            
		            $('#userProfileModal').modal('hide');
		            $(e.target).removeClass('disabled');
		            $('.modal-body').unblock();
		
				});

	        }).catch(function (error) {
	        	console.log(error);
	        });
        }
		
	}

	onSavePhoto = (form,e) => {

		// disabled button
		let button = $(e.target);
        button.addClass('disabled');

		const url = appConfig.apiUrl + 'media/upload';
		
		axios({
            url: url,
            method: 'post',
            responseType: 'json',
            data : form,
            progress: (progressEvent) => {
		        let percentCompleted = progressEvent.loaded / progressEvent.total;
			        
		        let html = (percentCompleted * 100) + '% completed';
		        
		        $('.modal-body').block({
		        	message : html
		        });
		    }
        }).then((response) => {

        	this.onCancel();
            
            this.setState({
                savedImg: appConfig.staticFiles + response.data.data.name
            },() => {
            	document.getElementById('media_id').value = response.data.data.name;

            	// if(this.props.scrollState == 'profile')
	            // {
	            // 	$('.tenantProfilePic').attr('src',appConfig.staticFiles + response.data.data.name);
	            // }

	            this.props.onMediaChoice(e);

            	$('#userProfileModal').modal('hide');
            	button.removeClass('disabled');
            	$('.modal-body').unblock();
            });


        }).catch(function (error) {
        	console.log(error);
        });
	}

	onCamera = () => {
		this.setState({
			visibleCamera : true,
			visible : false
		});
	}

	onErrorImg = (e) => {
		e.target.src = '/images/generic_profile_pic.png';
	}

	handlePDF = (e) => {
		$('#modalPrintPDF').modal('show');
	}

    handleSendMessage = (e) => {
        $('#smsModal').modal('show');
    }

	makePrintPDF = (e) => {

		let form = $('#formPrintChoice').serialize();

		let formData = this.state.checkedItems;

		let session = localStorage.getItem('token');

		let url = `${appConfig.apiUrl}patients/${this.state.showId}/medical-abstracts?access_token=${session}&${form}`;
		
		$('#previewPDF').find('iframe').prop('src', url);
		$('#previewPDF').modal('show');
	};

	closeModal = (e) => {
		
	}

	handleClickCheckbox = (e) => {
		let val = e.target.value;
		let checkedItems = this.state.checkedItems;

		if(e.target.checked)
		{
			checkedItems[val] = 1;

			this.setState({
				checkedItems
			});
			return;
		}
		
		delete checkedItems[val];
		this.setState({
			checkedItems
		});

	}

	handleCloseModal = () => {

	}

	handleDeletePatient = () => {
		let patientId = this.state.showId;
		let url = appConfig.apiUrl + 'dental/patients/' + patientId;

        axios.delete(url).then((res) => {
        	$('#deletePatientModalFromPatientInfo').modal('hide');
        	browserHistory.push('/patients');
        }).catch((error) => {
            console.log(error);
        });
	}

	handleDeletePatientModal = () => {
		$('#deletePatientModalFromPatientInfo').modal('show');
	}

	render() {

		return (
			/*<img src={this.state.savedImg ? this.state.savedImg : '/images/generic_profile_pic.png'} className="img-responsive" id="imgProfilePic" onError={this.onErrorImg} style={{border: '2px solid #ECEFF2',width : '65%'}} />*/
			<div className="portlet light blockContentUi" style={this.state.styleChange}>
				{this.state.profilePosition ? 
				
				(<div className="row">
					<div className="col-md-2 col-sm-6 col-xs-6">
						<div className="profile-userpic">
							<a href="#" data-target="#userProfileModal" data-toggle="modal">
								<div style={{backgroundImage : 'url('+ (this.state.savedImg ? this.state.savedImg : "/images/generic_profile_pic.png") +')',backgroundRepeat: 'no-repeat',backgroundSize: 'cover',backgroundPosition: '50% 50%',height: '115px',width: '115px',border: '2px solid #ECEFF2',borderRadius: '50%'}}></div>
							</a>
						</div>
					</div>
					<div className="col-md-3 col-sm-6 col-xs-6" style={{margin: '25px 0',borderRight: '1px solid #ddd'}}>
						<div className="text-left">
							<h4><strong> {this.state.patient_name} </strong></h4>
							{!this.props.scrollState ? 
								(<div className="profile-usertitle-name">Patient No. {this.state.showId} </div>)
								: 
								null
							}
			                
			                {/*<div className="profile-usertitle-name"> {this.state.age ? moment().diff(this.state.age, 'years') + ' Years Old' : ''} </div>*/}
			            </div>
		            </div>
		            <div className="col-md-5 col-sm-12 col-xs-12" style={{marginTop: '35px'}}>
		            	<div className="col-md-4 col-md-offset-2">
		            		<label style={{color: '#888'}}>Age:&nbsp;&nbsp;</label><strong>{this.state.age ? moment().diff(this.state.age, 'years') : 'N/A'}</strong>
		            	</div>
		            	<div className="col-md-6">
		            		<label style={{color: '#888'}}>Civil Status:&nbsp;&nbsp;</label><strong style={{textTransform : 'capitalize'}}>{this.state.civil_status != null ? this.state.civil_status : 'N/A'}</strong>
		            	</div>
		            	<div className="col-md-4 col-md-offset-2">
		            		<label style={{color: '#888'}}>Gender:&nbsp;&nbsp;</label><strong>{this.state.gender == 1 ? 'Male' : 'Female'}</strong>
		            	</div>
		            	<div className="col-md-6">
		            		<label style={{color: '#888'}}>Contact Number:&nbsp;&nbsp;</label><strong>{this.state.contact_number}</strong>
		            	</div>
		            </div>
		            {!this.props.scrollState ? 
			            /*<div className="col-md-2 col-sm-12 col-xs-12 text-center" style={{marginTop: '35px'}}>
			            	<a href="#" className="btn blue" onClick={this.handlePDF}>Save PDF</a>
			            </div>*/
			            <div className="col-md-2 col-sm-12 col-xs-12 text-center" style={{marginTop: '35px'}}>
				            <div className="btn-group">
	                            <button className="btn blue dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
	                            	Action
	                                <i className="fa fa-angle-down"></i>
	                            </button>
	                            <ul className="dropdown-menu pull-right">
									<li>
										<a href="javascript:;" onClick={this.handleSendMessage}>
											<i className="fa fa-envelope"/>
											Send Message
										</a>
									</li>
	                                <li>
	                                    <a href="javascript:;" onClick={this.handlePDF}> 
	                                    	<i className="fa fa-print"></i>
	                                    	Save PDF 
	                                    </a>
	                                </li>
	                                <li>
	                                    <a href="javascript:;" onClick={this.handleDeletePatientModal}> 
	                                    	<i className="fa fa-times"></i>
	                                    	Delete
	                                    </a>
	                                </li>
	                            </ul>
	                        </div>
                        </div>
			            :
			            null
			        }
	            </div>)

	            :

	            (<div className="row">
	            	<div className="col-md-1 col-xs-6 col-sm-6">
						<div className="profile-userpic">
							<a href="#" data-target="#userProfileModal" data-toggle="modal">
								<div style={{backgroundImage : 'url('+ (this.state.savedImg ? this.state.savedImg : "/images/generic_profile_pic.png") +')',backgroundRepeat: 'no-repeat',backgroundSize: 'cover',backgroundPosition: '50% 50%',height: '50px',width: '50px',border: '2px solid #ECEFF2',borderRadius: '50%'}}></div>
							</a>
						</div>
					</div>
					<div className="col-md-2 col-xs-6 col-sm-6" style={{borderRight: '1px solid #ddd'}}>
						<div className="text-left">
							<strong> {this.state.patient_name} </strong>
			                <div className="profile-usertitle-name">Patient No. {this.state.showId} </div>
			                {/*<div className="profile-usertitle-name"> {this.state.age ? moment().diff(this.state.age, 'years') + ' Years Old' : ''} </div>*/}
			            </div>
		            </div>
		            <div className="col-md-2 col-xs-12 col-sm-12" style={{marginTop: '10px'}}>
	            		<label style={{color: '#888'}}>Age:&nbsp;&nbsp;</label><strong>{this.state.age ? moment().diff(this.state.age, 'years') : ''}</strong>
	            	</div>
	            	<div className="col-md-2 col-xs-12 col-sm-12" style={{marginTop: '10px'}}>
	            		<label style={{color: '#888'}}>Civil Status:&nbsp;&nbsp;</label><strong style={{textTransform : 'capitalize'}}>{this.state.civil_status != null ? this.state.civil_status : 'N/A'}</strong>
	            	</div>
	            	<div className="col-md-2 col-xs-12 col-sm-12" style={{marginTop: '10px'}}>
	            		<label style={{color: '#888'}}>Gender:&nbsp;&nbsp;</label><strong>{this.state.gender == 1 ? 'Male' : 'Female'}</strong>
	            	</div>
	            	<div className="col-md-2 col-xs-12 col-sm-12" style={{marginTop: '10px'}}>
	            		<label style={{color: '#888'}}>Contact No:&nbsp;&nbsp;</label><strong>{this.state.contact_number}</strong>
	            	</div>
	            	<div className="col-md-1 col-sm-12 col-xs-12 text-center">
		            	<div className="btn-group">
	                            <button className="btn blue dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
	                            	Action
	                                <i className="fa fa-angle-down"></i>
	                            </button>
	                            <ul className="dropdown-menu pull-right">
									<li>
										<a href="javascript:;" onClick={this.handleSendMessage}>
											<i className="fa fa-envelope"/>
											Send Message
										</a>
									</li>
	                                <li>
	                                    <a href="javascript:;" onClick={this.handlePDF}> 
	                                    	<i className="fa fa-print"></i>
	                                    	Save PDF 
	                                    </a>
	                                </li>
	                                <li>
	                                    <a href="javascript:;" onClick={this.handleDeletePatientModal}> 
	                                    	<i className="fa fa-times"></i>
	                                    	Delete
	                                    </a>
	                                </li>
	                            </ul>
	                        </div>
		            </div>
		        </div>)

		        }
	            <Modal id="userProfileModal">

	            	<DefaultBody upload={this.onUpload} camera={this.onCamera} visibility={this.state.visible} id="uploadFileForm" />

	            	<UploadFile element={this.state.imgSrc} onCancel={this.onCancel} onSave={this.onSave} visibility={this.state.visibleUpload} />

	            	<Camera visibility={this.state.visibleCamera} onCancel={this.onCancel} onSavePhoto={this.onSavePhoto} />

	            </Modal>

	            <ModalCommon
                    id="deletePatientModalFromPatientInfo"
                    header="DELETE"
                    onNegativeClickEvent={this.handleCloseModal}
                    onPositiveClickEvent={this.handleDeletePatient}
                    positiveButton="Delete"
                    buttonBackgroundColor="btn red"
                    isSaving={this.state.isDeleting}
                    loadingText="Deleting"
                    width="320">

                    <div className="container-fluid">
                        <p>Are you sure you want to delete this patient?</p>
                    </div>

                </ModalCommon>

	            <ModalCommon
                    id="modalPrintPDF"
                    header="Print options"
                    onNegativeClickEvent={this.closeModal}
                    onPositiveClickEvent={this.makePrintPDF}
                    isSaving={this.state.isSaving}
                    negativeButton="Cancel"
                    positiveButton="Print"
                    width="640">


                    <form id="formPrintChoice">
                    	<div className="row">
                    		<div className="col-md-4 col-md-offset-3">
                    			<Checkbox name="patientInfo" id="pInfo" label="Patient Info" onchange={this.handleClickCheckbox} value="patientInfo" key="0" index="0" checkedItems={this.state.checkedItems} />
                    		</div>
                    		<div className="col-md-5">
                    			<Checkbox name="dentalHistory" id="denHistory" label="Dental History" onchange={this.handleClickCheckbox} value="dentalHistory" key="0" index="0" checkedItems={this.state.checkedItems} />
                    		</div>
                    	</div>
                    	<div className="row">
                    		<div className="col-md-4 col-md-offset-3">
                    			<Checkbox name="medicalHistory" id="medHistory" label="Medical History" onchange={this.handleClickCheckbox} value="medicalHistory" key="0" index="0" checkedItems={this.state.checkedItems} />
                    		</div>
                    	</div>
                    </form>
                </ModalCommon>

                <SMSModal smsData={this.props.data} />

				<div id="previewPDF" data-width="900" className="modal fade in" tabIndex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">
					<div className="modal-content">
						<div className="modal-header">
							<button type="button" className="close" onClick={this.handleClosePDFPreview} data-dismiss="modal" aria-hidden="true" />
							<h4 className="modal-title">Medical Abstract</h4>
						</div>
						<div className="modal-body">
							<iframe style={{ width: '100%', height: '500px'}}></iframe>
						</div>
					</div>
				</div>

		        <div id="alertNotif"></div>
	        </div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/UserProfile.js
 **/